export default __webpack_public_path__ + "static/media/MB Marketing.4ddb7796.jpg";